import React from "react"
import PropTypes from "prop-types"
import Grid from "./Grid"
import { getPath } from "../../pages/ClaimAnalysisPage/ClaimViewPage/PatientDetails"
import Period from "./Period"
import moment from "moment"
import SelectionCheckbox from "./SelectionCheckbox.jsx"

export default class CarePlan extends React.Component {
    static propTypes = {
        resources: PropTypes.array,
        onSelectionChange: PropTypes.func,
    };

    render() {
        const RowCount = this.props.resources.length || 0
        return (
            <Grid
                rows={(this.props.resources || []).map(o => o.resource)}
                title={`${RowCount} CarePlan`}
                groupBy="Category"
                comparator={(a, b) => {
                    let dA = getPath(a, "period.start");
                    let dB = getPath(b, "period.start");
                    dA = dA ? +moment(dA) : 0;
                    dB = dB ? +moment(dB) : 0;
                    return dB - dA;
                }}
                cols={[
                    {
                        label: <div className="text-center">Select</div>,
                        render: o => (
                            <div className="text-center">
                                <SelectionCheckbox
                                    row={o}
                                    checked={o.isSelected}
                                    onSelectionChange={this.props.onSelectionChange}
                                />
                            </div>
                        )
                    },
                    {
                        label: "Category",
                        path: "category.0.coding.0.display",
                        render: rec => (
                            <b>
                                {getPath(rec, "category.0.coding.0.display")}
                            </b>
                        )
                    },
                    {
                        label: "Reason",
                        render: rec => (rec.activity || []).map((a, i) => {
                            let reason = getPath(a, "detail.code.coding.0.display") || ""
                            return reason ? (
                                <div key={i}>
                                    {reason}
                                    <span> - </span>
                                    <span className="text-muted">{
                                        getPath(a, "detail.status") || "no data"
                                    }</span>
                                </div>
                            ) : ""
                        })
                    },
                    {
                        label: "Period",
                        render: o => Period(o.period)
                    },
                    {
                        label: "Status",
                        path: "status"
                    }
                ]}
            />
        )
    }
}

